import React, { FC } from "react";
import { getResources } from "../../utils/constants";
// export interface IYhAuth {
//     resCode: string;
//     isShow?: boolean;  //强制渲染， 不去查询是否具有用户权限。
// }


export const YhAuth = (props) => {
    let resourceAuth = getResources() ?? [];
    const hasAuth = (resCode, isShow) => {
        if (isShow) return true;
        //判断当前用户是否具有资源访问权限
        return !!resourceAuth.find(item => item === resCode);
    }
    const { resCode, isShow, children } = props
    return hasAuth(resCode, isShow) ? <>{children}</> : null
}